import { Tabs, TabsProps } from 'antd';
import ScheduleSettings from './Settings/ScheduleSettings';
import GeneralSettings from './Settings/GeneralSettings';

const CampaignSettings = () => {
	const items: TabsProps['items'] = [
		{
			key: 'general-settings',
			label: 'General Settings',
			children: <GeneralSettings />,
		},
		{
			key: 'schedule-settings',
			label: 'Schedule Settings',
			children: <ScheduleSettings />,
		},
	];
	return (
		<div className="p-4">
			<Tabs defaultActiveKey="1" items={items} />
		</div>
	);
};

export default CampaignSettings;
